module.exports = __webpack_public_path__ + "media/921_sound_10.f075789d.mp3";